var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.19471 1.95622C9.04132 1.63678 8.80079 1.36717 8.50084 1.17847C8.2009 0.989767 7.85374 0.889648 7.49938 0.889648C7.14501 0.889648 6.79786 0.989767 6.49791 1.17847C6.19797 1.36717 5.95744 1.63678 5.80404 1.95622L0.393378 12.5996C-0.253956 13.8702 0.564044 15.5576 2.08804 15.5576H12.91C14.4347 15.5576 15.2514 13.8709 14.6054 12.5996L9.19471 1.95622ZM7.49938 5.55755C7.67619 5.55755 7.84576 5.62779 7.97078 5.75282C8.09581 5.87784 8.16604 6.04741 8.16604 6.22422V9.55755C8.16604 9.73436 8.09581 9.90393 7.97078 10.029C7.84576 10.154 7.67619 10.2242 7.49938 10.2242C7.32257 10.2242 7.153 10.154 7.02797 10.029C6.90295 9.90393 6.83271 9.73436 6.83271 9.55755V6.22422C6.83271 6.04741 6.90295 5.87784 7.02797 5.75282C7.153 5.62779 7.32257 5.55755 7.49938 5.55755ZM7.49938 11.2242C7.67619 11.2242 7.84576 11.2945 7.97078 11.4195C8.09581 11.5445 8.16604 11.7141 8.16604 11.8909V12.2242C8.16604 12.401 8.09581 12.5706 7.97078 12.6956C7.84576 12.8206 7.67619 12.8909 7.49938 12.8909C7.32257 12.8909 7.153 12.8206 7.02797 12.6956C6.90295 12.5706 6.83271 12.401 6.83271 12.2242V11.8909C6.83271 11.7141 6.90295 11.5445 7.02797 11.4195C7.153 11.2945 7.32257 11.2242 7.49938 11.2242Z",
    fill: "#FFB74A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningYellow);
export default __webpack_public_path__ + "static/media/warning-yellow.3579a1015718c48f298602a07e86071e.svg";
export { ForwardRef as ReactComponent };